import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import trustedRiskGraph from '@/assets/images/modals/risk/low-risk-graph-example.svg';
import suspiciousRiskGraph from '@/assets/images/modals/risk/risk-zone-graph-example.svg';
import dangerRiskGraph from '@/assets/images/modals/risk/extreme-danger-graph-example.svg';

import { ModalInfo, ModalInfoProps } from '../ModalInfo';

import styles from './AboutRiskScoreModal.module.sass';

interface AboutRiskScoreModalProps extends ModalInfoProps {}

const AboutRiskScoreModal: FC<AboutRiskScoreModalProps> = (props) => {
  const { t } = useTranslation();
  const { isOpen, onClose } = props;
  const title = t('translation.riskscore_more_btn');

  return (
    <ModalInfo
      isOpen={isOpen}
      title={title}
      className={styles.modal}
      onClose={onClose}
    >
      <div className={styles.list}>
        <div className={`${styles.item} ${styles['item--trusted']}`}>
          <div className={styles.item__graph}>
            <img src={trustedRiskGraph} alt="20%" />
          </div>
          <div className={styles.body}>
            <h3 className={styles.item__title}>
              {t('translation.risk_group_low_title')}
            </h3>
            <p className={styles.item__description}>
              {t('translation.risk_group_low_description')}
            </p>
          </div>
        </div>

        <div className={`${styles.item} ${styles['item--suspicious']}`}>
          <div className={styles.item__graph}>
            <img src={suspiciousRiskGraph} alt="50%" />
          </div>
          <div className={styles.body}>
            <h3 className={styles.item__title}>
              {t('translation.risk_group_medium_title')}
            </h3>
            <p className={styles.item__description}>
              {t('translation.risk_group_medium_description')}
            </p>
          </div>
        </div>

        <div className={`${styles.item} ${styles['item--danger']}`}>
          <div className={styles.item__graph}>
            <img src={dangerRiskGraph} alt="80%" />
          </div>
          <div className={styles.body}>
            <h3 className={styles.item__title}>
              {t('translation.risk_group_high_title')}
            </h3>
            <p className={styles.item__description}>
              {t('translation.risk_group_high_description')}
            </p>
          </div>
        </div>
      </div>
    </ModalInfo>
  );
};

export default AboutRiskScoreModal;
